export default __webpack_public_path__ + "static/media/objectives-lady.bf23634a.svg";